import React from 'react';
import { Link } from 'react-router-dom';

const CategorySection = ({ categories }) => {

     const targetCategories = ['chatgpt-prompts', 'google-gemini-prompts', 'midjourney-prompts'];

     return (
          <>
               <section className='category-container'>
                    <div className="__container">
                         {targetCategories.map((key) => {
                              const category = categories[key];

                              if (!category) return null;

                              return (
                                   <section key={key} className="category-block">
                                        <div className="category-header">
                                             <h2> +{category?.categoryListAll.length}.  {category.name} Prompts</h2>
                                             <p>{category.paragraph}</p>
                                             <span className="model-tag">Model: {category.modal}</span>
                                        </div>

                                        <div className="card-list-in">
                                             {category.categoryListAll.map((item, index) => (
                                                  item.show && (
                                                       <div key={index} className="home-category-card">
                                                            <div className="image-box">
                                                                 <img src={`https://res.cloudinary.com/dqwbmkrm8/image/upload/v1772471958/${item.image}`} alt={item?.imageAlt} />
                                                                 <div className="badge">{item.nameOfList}</div>
                                                            </div>
                                                            <div className="content">
                                                                 <small> Update : {item.date}</small>
                                                                 <h3><Link to={item.url}>{item.title}</Link></h3>
                                                                 <p>{item.excerpt}</p>
                                                                 <div className="footer">
                                                                      <Link to={item.url} className="read-more">View Prompt →</Link>
                                                                 </div>
                                                            </div>
                                                       </div>
                                                  )
                                             ))}
                                        </div>
                                   </section>
                              );
                         })}
                    </div>
               </section>
          </>
     );
};

export default CategorySection;